// Extension point for the concessions views. A view places <Slot name="..." /> where custom content
// may go; it renders nothing unless the open stand has something registered for that slot.
import React, { Suspense } from 'react';
import { CONCESSION_EXTENSIONS } from './registry';

// The open stand's extensions, or null (the logged-in user's venue + the stand's id)
export const getConcessionExtension = (authCtx, currentLocation) =>
  CONCESSION_EXTENSIONS[`${authCtx?.venue}:${currentLocation?.id}`] || null;

export const hasSlot = (extension, name) => !!extension?.slots?.[name];

export const Slot = ({ name, extension, ...props }) => {
  const Component = extension?.slots?.[name];
  if (!Component) return null;
  return (
    <Suspense fallback={null}>
      <Component {...props} />
    </Suspense>
  );
};
